import * as types from '../types'

// get user from localStorage
const initialState = {
    loading: false,
    users: [],
    user: {},
    error: null
}

export const userReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.CREATE_USER:
            return {
                ...state,
                users: [...state.users, action.payload],
                loading: false,
                error: null
            }
        case types.GET_USERS:
            return {
                ...state,
                users: action.payload,
                loading: false,
                error: null
            }

        case types.SET_LOADING:
            return {
                ...state,
                loading: true,
                error:null
            }
            case types.RESET_LOADING:
                return {
                    ...state,
                    loading: true,
                    error:null
                }
        case types.RESET:
            return {
                ...state,
                loading: false,
                error:null
            }
        case types.SET_ERROR:
            return {
                ...state,
                error: action.payload,
                loading: false
            }
        default:
            return state
    }
}